import { call, put, take } from 'redux-saga/effects';

import { captureException } from '@skippay/core/global/errorTracking';

import { SET_FULL_ACCESS, login } from '../actions';
import { getTokenData, getValidAccessToken } from '../utils/accessTokenUtils';

export function* setFullAccessSaga() {
	while (true) {
		yield take(SET_FULL_ACCESS);
		const tokenDataValid = yield call(getValidAccessToken);
		if (!tokenDataValid) {
			captureException(
				new Error(
					`The 'setFullAccess' redux action for auth module must be dispatched only when there is valid access token stored already.`
				),
				{
					level: 'error',
				}
			);
			return;
		}
		const tokenData = yield call(getTokenData);
		yield put(
			login({
				accessToken: tokenData.accessToken,
				expiresIn: tokenData.expiresIn,
				fullAccess: true,
			})
		);
	}
}
